// Stub for @finn-auto/design-system/helpers/media.
// The DS module imports `../../tailwind.config` which is not shipped in the npm
// package — Rollup fails to resolve it during production builds. Vite aliases
// the module to this stub instead (see vite.config.ts).
import { useEffect, useState } from 'react';

const SIZES: Record<string, string> = {
  xs: '0',
  mobile: '375px',
  sm: '600px',
  md: '1120px',
  lg: '1440px',
  xl: '1920px',
  max: '2100px',
};

export const useHasHover = () => {
  try {
    return matchMedia('(hover: hover)').matches;
  } catch {
    return true;
  }
};

export const useMediaQuery = (size: string): boolean => {
  const [value, setValue] = useState(false);
  useEffect(() => {
    const max = SIZES[size];
    if (!max) return;
    try {
      const onChange = (event: MediaQueryListEvent) => setValue(event.matches);
      const result = matchMedia(`(max-width: ${max})`);
      result.addEventListener?.('change', onChange);
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setValue(result.matches);
      return () => result.removeEventListener?.('change', onChange);
    } catch {
      setValue(false);
      return;
    }
  }, [size]);
  return value;
};
